import { getAnalytics } from "@tm/insurance/analytics";
import {
  FlexComp,
  FormattedText,
  H3Tag,
  LandingButton,
  ParaTag,
} from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import { TextNodeType } from "../FormattedText/FormattedText";
import MarkdownText from "../MarkdownText/MarkdownText";
import { PersuasionBannerStyle } from "./PersuasionBanner.style";

interface PersuasionBannerProps {
  crossSell?: {
    title?: string | TextNodeType;
    description?: string;
    background?: { url?: string };
    info?: string | TextNodeType;
    cta?: {
      title?: string;
    };
  };
  btnHandler?: () => void;
}

const PersuasionBannerInsurance = ({
  crossSell,
  btnHandler,
}: PersuasionBannerProps) => {
  const device = useBreakpointV2();
  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback((data: IntersectionObserverData) => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "persuasion_banner_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: persuasionBannerRef } = useIntersectionObserver(
    handleIntersection,
    {
      threshold: 0.5, // Trigger when 50% of component is visible
      triggerOnLeaveViewport: true,
    }
  );

  if (!crossSell) {
    return null;
  }
  const { title, background, description, cta, info } = crossSell;
  return (
    <PersuasionBannerStyle ref={persuasionBannerRef} bgImage={background?.url}>
      {title && (
        <H3Tag>
          <FormattedText value={title} />
        </H3Tag>
      )}
      {device === "sm" && (
        <FlexComp gap="6px">
          <ParaTag>
            <FormattedText value={info} />
          </ParaTag>
        </FlexComp>
      )}
      {description && <MarkdownText value={description} />}
      <LandingButton
        customTitle={cta?.title}
        onClick={btnHandler}
        padding="0px 40px"
      />
    </PersuasionBannerStyle>
  );
};

export default PersuasionBannerInsurance;
